import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import facilityService from "../services/facility-service";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import cogoToast from "cogo-toast";
import "react-datepicker/dist/react-datepicker.css";
import refillService from "../services/refill-service";
import "react-datetime/css/react-datetime.css";
import Datetime from "react-datetime";

const AddRefillTimeEntry = ({
  name,
  editData,
  dayOptions,
  onCloseRepModal,
}) => {
  const [loading, setLoading] = useState(false);
  const [facList, setFacList] = useState([]);
  const [facility, setFacility] = useState(editData?.fac_id);
  const [day, setDay] = useState(editData?.day_name);
  const [time, setTime] = useState(editData?.time_stamp || "00.00.00");
  useEffect(() => {
    setLoading(false);
    getFacilities();
  }, []);
  useEffect(() => {
    setDay(editData?.day_name);
    setFacility(editData?.fac_id);
    setTime(editData?.time_stamp || "00.00.00");
  }, [editData]);

  const handleSubmit = async () => {
    var params = {
      fac_id: facility,
      day_name: day,
      time_stamp: time?.length === 9 ? time + ".000" : time,
    };
    try {
      if (editData.id) {
        await refillService.updateEntry(editData.id, params);
      } else {
        await refillService.createEntry(params);
      }

      onCloseRepModal();
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error saving the refill time. Please contact administrator.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  async function getFacilities(parentId) {
    try {
      setLoading(true);
      let totalFacList = await facilityService.getFacilities();
      if (totalFacList) {
        setFacList(totalFacList);
      }
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error while getting facilities details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  }

  return (
    <>
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <div className="text-xl">{name}</div>
      <div className="bg-white w-full mx-auto mt-6 mb-4 rounded h-96 ">
        <div className="p-2 text-xs">
          <ul>
            <li className={`inline-block text-sm leading-8 w-11/12 pt-4`}>
              <label>Facility</label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <select
                name="perFacility"
                aria-label="Select Facility"
                disabled={editData?.fac_id === 0}
                onChange={(e) => setFacility(e.target.value)}
                value={facility}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="">Select Facility</option>
                {facList
                  ? facList.map((facility, i) => {
                      return (
                        <option key={i} value={facility.id}>
                          {facility.name}
                        </option>
                      );
                    })
                  : null}
              </select>
            </li>
            <li className={`inline-block text-sm leading-8 w-11/12 pt-4`}>
              <label>Day</label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <select
                name="selectday"
                aria-label="Select day"
                onChange={(e) => setDay(e.target.value)}
                value={day}
                disabled={editData?.day_name === "-"}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="">Select day</option>
                {dayOptions.map((item, i) => {
                  return (
                    <option key={item.key} value={item.key}>
                      {item.value}
                    </option>
                  );
                })}
              </select>
            </li>
            <li className={`inline-block text-sm leading-8 w-11/12 pt-4`}>
              <label>Time</label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <div className="border w-full">
                <Datetime
                  dateFormat={false}
                  initialValue={time || "00.00.00"}
                  className={"w-full"}
                  inputProps={{ className: "w-full" }}
                  onChange={(val) =>
                    setTime(val?._d.toTimeString().split(" ")[0])
                  }
                />
              </div>
            </li>

            <li className="text-center">
              <button
                disabled={loading}
                onClick={() => handleSubmit()}
                className={
                  loading
                    ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    : "text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                }
              >
                SAVE
              </button>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(AddRefillTimeEntry)
);
